import ApolloClient from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { errorLink, authLink, link } from './links';
import { cache } from './cache';

export const client = new ApolloClient({
  cache,
  link: ApolloLink.from([authLink, errorLink, link]),
});
